import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Injector,
    OnInit,
    Output,
    ViewEncapsulation,
    Input,
} from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { ReportWidgetDetailsFilterTableBaseDirective } from '../../../shared/report-widget-details-filter-table-base.directive';
import {
    IChecklist2ReportAnswer,
    IChecklist2ReportChecklistSummary,
    IChecklistReportDetailsData,
} from '../../../shared/fi-checklist2-report';
import { cloneDeep } from '@fi-shared/utils';
import { FiChecklist2ReportOpenChecklistsService } from '@fi-shared/checklist/fi-checklist2-report/services/fi-checklist2-report-open-checklists.service';
import { WidgetTableFilterType } from '@fi-shared/checklist/fi-checklist2-report/enums/fi-checklist2-report-type';

@Component({
    selector: 'fi-open-checklists-summary-table-wrapper',
    templateUrl: './open-checklists-summary-table-wrapper.component.html',
    styleUrls: ['./open-checklists-summary-table-wrapper.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-open-checklists-summary-table-wrapper' },
    standalone: false,
})
export class FiOpenChecklistsSummaryTableWrapperComponent
    extends ReportWidgetDetailsFilterTableBaseDirective
    implements OnInit
{
    @Output() onFilteredChecklistsChange = new EventEmitter<IChecklist2ReportChecklistSummary[]>();
    @Output() onFilteredNotOkAnswerDetailsChange = new EventEmitter<IChecklist2ReportAnswer[]>();
    @Output() onOpenChecklistReportDetails = new EventEmitter<IChecklistReportDetailsData>();

    private _filteredChecklists$ = new BehaviorSubject<IChecklist2ReportChecklistSummary[]>([]);
    get filteredChecklists$() {
        return this._filteredChecklists$.asObservable();
    }

    constructor(
        injector: Injector,
        private fiChecklist2ReportOpenChecklistsService: FiChecklist2ReportOpenChecklistsService,
    ) {
        super(injector);
    }

    ngOnInit() {
        super.ngOnInit();

        // use initial checklists data when open checklists summary table
        this.setNewOpenChecklistsSummaryData(this.reportData.getOpenChecklistsSummary(this.reportParam.Id));
    }

    private setNewOpenChecklistsSummaryData(openChecklistsSummary: IChecklist2ReportChecklistSummary[]) {
        this._filteredChecklists$.next(openChecklistsSummary);
        this.onFilteredChecklistsChange.emit(this._filteredChecklists$.value);

        this.loadNotOkAnswerDetails();
    }

    private loadNotOkAnswerDetails(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.fiChecklist2ReportOpenChecklistsService
                .getDeviationDetails(this.currentFilter, this.reportData.auditMode)
                .then((notOkAnswerDetails) => {
                    this.onFilteredNotOkAnswerDetailsChange.emit(notOkAnswerDetails);
                });
        });
    }

    selectedFilterItemsChanged() {
        this.onCurrentFilterChanged();
        this.fiChecklist2ReportOpenChecklistsService
            .getOpenChecklistsSummary(this.currentFilter, this.reportData.auditMode)
            .then((data) => {
                this.setNewOpenChecklistsSummaryData(data);
            });
    }

    openChecklistDetails(checklistSummary: IChecklist2ReportChecklistSummary) {
        this.onOpenChecklistReportDetails.emit({
            selectedItem: checklistSummary,
            filter: cloneDeep(this.currentFilter),
        });
    }

    protected readonly WidgetTableFilterType = WidgetTableFilterType;
}
